"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("../forms/Button"));
const Presets_1 = require("../Pages/Presets");
const PresetsGroupRenderer = (props) => {
    const node = props.node;
    const { value } = props;
    const refreshUi = () => {
        const node = props.node;
    };
    const handleClick = () => {
        props.handleAddNew(value);
    };
    const dataChangedListener = () => refreshUi();
    (0, react_1.useEffect)(() => {
        props.api.addEventListener('cellValueChanged', dataChangedListener);
        props.api.addEventListener('filterChanged', dataChangedListener);
        return () => {
            props.api.removeEventListener('cellValueChanged', dataChangedListener);
            props.api.removeEventListener('filterChanged', dataChangedListener);
        };
    }, []);
    return (react_1.default.createElement("div", { className: "inline-block" },
        react_1.default.createElement(Button_1.default, { size: 'sm', variant: 'secondary', onClick: handleClick }, "Neuer Wert"),
        react_1.default.createElement("span", { className: "pl-2 font-medium inline-block text-sm" }, (0, Presets_1.getPresetNames)(value))));
};
exports.default = PresetsGroupRenderer;
